/* eslint-disable no-restricted-globals */
// Ajout du fichier dans le DOM du formulaire
export default {
  methods: {
    mixinAddFile_addFile() {
      let files = {};
      const eventType = event.type;
      const vm = this;
      const { uploadElementPosition } = this;
      const erreurPremier = document
        .querySelector('#erreur-televersement-premier')
        .querySelector('#televersement__errors');
      const erreurDeuxieme = document
        .querySelector('#erreur-televersement-deuxieme')
        .querySelector('#televersement__errors');
      let errorsToEdit = null;
      const warningsToEdit = document.querySelector('#televersement__warnings');

      if (uploadElementPosition == 'premier') {
        errorsToEdit = erreurPremier;
      } else {
        errorsToEdit = erreurDeuxieme;
      }

      vm.hideErrors(erreurPremier, 'premier');
      vm.hideErrors(erreurDeuxieme, 'deuxieme');

      vm.hideWarnings(errorsToEdit);

      if (eventType === 'drop') {
        event.preventDefault();
        files = event.dataTransfer.files;
      } else {
        files = event.target.files;
      }

      // À chaque ajout de fichier, on retire les messages d'erreurs génériques.

      // On bloque les ajouts multiples
      if (files.length > 1) {
        vm.showError(errorsToEdit, 'error-filesMultiple', uploadElementPosition);
        return;
      }

      Array.from(files).forEach(function (file) {
        // Validation Front des fichiers
        if (vm.fileTypes.indexOf(file.type) === -1) {
          // Si le format n'est pas supporté
          vm.showError(errorsToEdit, 'error-type', uploadElementPosition);
        } else if (file.size > vm.fileMaxSize) {
          // Si le poids du fichiers est trop lourd
          vm.showError(errorsToEdit, 'error-size', uploadElementPosition);
        } else {
          const fileType = file.type;
          const items = document.querySelectorAll('#televersement__preview-item-name');

          for (let i = 0; i < items.length; i++) {
            if (vm.files[i].name === file.name) {
              // Si le fichier courant a le même nom qu'un fichier déjà ajouté, on averti l'utilisateur.
              vm.showError(errorsToEdit, 'error-identical-name', uploadElementPosition);
              break;
            }
          }

          const reader = new FileReader();

          vm.files.push(file);

          reader.readAsDataURL(file);

          reader.onloadend = function () {
            const $newItem = document.createElement('div');
            const domainContext = window.location.origin;
            const imgPath =
              domainContext.indexOf('.espacejeux.local') >= 0
                ? ''
                : '/.resources/jel-lm/webresources/dist';
            const imgSrc =
              fileType === 'application/pdf'
                ? `${imgPath}/img/televersement/image-pdf.svg`
                : reader.result;
            const fileName =
              file.name.length > vm.fileNameLengthMax
                ? `${file.name.substring(0, vm.fileNameLengthMax)}...`
                : file.name;
            $newItem.innerHTML = `
            <div class="w-100">
              <div class="photo h-100 flex-row justify-content-end text-left">
                <img class="mw-100" src="${imgSrc}" alt="" />
              <span class="d-flex float-left" id="televersement__preview-item-name">${fileName}</span>
            </div>
            `;

            $newItem.id = 'televersement__preview-item';
            $newItem.setAttribute('data-is', 'file');
            document
              .querySelector(`#televersement__preview-area-${uploadElementPosition}`)
              .appendChild($newItem);
            document
              .querySelector(`#televersement__selection-area-${uploadElementPosition}`)
              .classList.add('d-none');
            document
              .querySelector(`#televersement__file-area-${uploadElementPosition}`)
              .classList.remove('d-none');
            document
              .querySelector(`[data-action="remove-file-${uploadElementPosition}"]`)
              .addEventListener('click', vm.removeFile(file, uploadElementPosition), {
                once: true,
              });
            document
              .querySelector(`#cadre-selection-document-${uploadElementPosition}`)
              .classList.add('bordure-cadre-transparent');
            document
              .querySelector(`#cadre-selection-document-${uploadElementPosition}`)
              .classList.remove('bordure-cadre-opaque');

            vm.filesWeakmap.set($newItem, { name: file.name }); // On ajoute une référence de l'élément avec son nom original dans le cas où l'on doit le tronquer.
          };

          vm.filesCount++;
          if (uploadElementPosition == 'premier') {
            vm.doc1Selectionne = true;
          } else if (uploadElementPosition == 'deuxieme') {
            vm.doc2Selectionne = true;
          }

          if (eventType === 'change') {
            document.querySelector(`#file-input-${uploadElementPosition}`).value = '';
          }

          if (vm.filesCount == vm.filesMax) {
            vm.showWarning(warningsToEdit, 'warning-televersement-final');
          }
        }
      });
    },
  },
};
